import _Promise from "babel-runtime/core-js/promise";
import _Set from "babel-runtime/core-js/set";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import oppService from "@/service/opp-service";
import { getImgClass, upCollectedImgData, deleteCollectedImgData, batchUpCollectedImgData, getKidmImgclsCollectFlag, getPrintImgClsCollectFlag } from "@/service/image-service";
export var imgCommonMixins = {
  methods: {
    assembusiData: function () {
      var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        var needOldImg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ignoreImgCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var vtmData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$store.commit(this.$types.UPDATE_LOADING, "正在更新数据...");
                _context.next = 4;
                return oppService.mergeMobileData();

              case 4:
                vtmData = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);

                this.historyData = _Object$assign(this.historyData, vtmData);

                this.bizData = _Object$assign(this.bizData, vtmData);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                alert("影像初始化失败：合并手机端数据失败!");
                consoleError("影像初始化失败：合并手机端数据失败!", _context.t0);

              case 13:
                this.busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO) || {};

                if (!(_.isEmpty(this.busiInfo) && this.$store.state.oldBizData)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 17;
                return oppService.parseAcceptParam(_.cloneDeep(this.$store.state.oldBizData));

              case 17:
                this.busiInfo = _context.sent;

              case 18:
                this.userInfo = this.$storage.getJsonSession(this.$definecfg.USER_INFO) || {};
                this.custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
                this.busiData = _Object$assign({}, this.busiInfo, {
                  B_SNO: this.$storage.getSession(this.$definecfg.B_SNO),
                  KIDM_SNO: this.$store.state.oldBizData.KIDM_SNO,
                  BUSI_SCOPE: this.$storage.getSession(this.$definecfg.BUSI_SCOPE),
                  BUSI_CODE: this.$store.state.busicode,
                  BUSI_DETAIL: "000",
                  SYS_CUST_NO: this.custInfo.CUST_CODE || "",
                  CUST_ORG_CODE: this.custInfo.INT_ORG || this.busiInfo.CUST_ORG_CODE || this.busiInfo.ORG_CODE,
                  ORG_CODE: this.custInfo.INT_ORG || this.busiInfo.CUST_ORG_CODE || this.busiInfo.ORG_CODE,
                  CUST_NAME: this.custInfo.CUST_NAME || this.custInfo.USER_NAME || this.custInfo.CUST_FNAME || this.USER_FNAME,
                  CUST_FNAME: this.custInfo.CUST_FNAME || this.custInfo.CUST_FNAME || "",
                  ID_TYPE: this.custInfo.ID_TYPE,
                  ID_CODE: this.custInfo.ID_CODE,
                  SYS_CODE: "99",
                  CHANNEL: this.busiInfo.CHANNEL || "",
                  CUST_CODE: this.$syscfg.isOpenAcctBiz(this.busiCode) ? "0" : this.custInfo.CUST_CODE || "0",
                  OP_USER: this.userInfo.OP_CODE,
                  OP_USER_CODE: this.userInfo.OP_CODE,
                  OP_USER_NAME: this.userInfo.USER_NAME,
                  USER_TYPE: this.custInfo.USER_TYPE || this.busiInfo.USER_TYPE || this.$store.state.usertype,
                  ORG_OPEN_TYPE: this.busiInfo.orgOpenType,
                  IS_OPEN_BIZ_CUST_CODE: this.$syscfg.isOpenAcctBiz(this.busiCode) ? this.busiInfo.NEW_CUST_CODE : ""
                });
                return _context.abrupt("return", this.getBusiCollectInfo(needOldImg, ignoreImgCls));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function assembusiData() {
        return _ref.apply(this, arguments);
      }

      return assembusiData;
    }(),
    getBusiCollectInfo: function getBusiCollectInfo(needOldImg, ignoreImgCls) {
      var _this = this;

      return _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
        var that, busiScope;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this;

                if (that.busiData.B_SNO) {
                  _context4.next = 5;
                  break;
                }

                that.$store.commit(_this.$types.UPDATE_LOADING, false);
                that.alert("当前流水号异常,当前流水号为：" + that.busiData.B_SNO);
                return _context4.abrupt("return");

              case 5:
                busiScope = that.busiData.BUSI_SCOPE || "2";

                that.$store.commit(that.$types.UPDATE_LOADING, "正在获取影像...");
                return _context4.abrupt("return", getImgClass(that.busiData.B_SNO, busiScope, that.busiData).then(function () {
                  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(IMG_CLSData) {
                    var _this2 = this;

                    var imgAllArr;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            consoleLog("获取影像列表返回数据", IMG_CLSData);

                            if (!(IMG_CLSData.Code != "0")) {
                              _context3.next = 7;
                              break;
                            }

                            that.$store.commit(that.$types.UPDATE_LOADING, false);
                            throw "影像类别查询失败" + IMG_CLSData.Msg;

                          case 7:
                            if (!(IMG_CLSData.Data.length == 0)) {
                              _context3.next = 13;
                              break;
                            }

                            that.$store.commit(that.$types.UPDATE_LOADING, false);
                            that.confirm({
                              messageText: "当前业务未配置影像，请联系管理员",
                              confirmButtonText: "重试",
                              cancelButtonText: "返回首页",
                              confirmedAction: function confirmedAction() {
                                return that.getBusiCollectInfo(needOldImg, ignoreImgCls);
                              },
                              canceledAction: function canceledAction() {
                                that.$router.push({ path: "/homeCustomer" });
                              }
                            });
                            return _context3.abrupt("return");

                          case 13:
                            consoleLog("获取影像列表返回数据：", _.pluck(IMG_CLSData.Data, "IMG_CLS").join(","));

                            that.imgClsArr = IMG_CLSData.Data.filter(function (obj) {
                              return obj.IMG_GROUP != "01";
                            });

                            that.imgClsArr.push({
                              IMG_CLS: "x9999",
                              IMG_CLS_NAME: "未识别影像"
                            });
                            imgAllArr = [];

                            that.imgClsArr.forEach(function (val) {
                              that.$set(val, "REVIEW_STATUS", "-1");
                              that.$set(val, "IMG_DATA", []);
                              that.$set(val, "SHOW_COLLECT_TIP", "未上传");
                              imgAllArr.push(val.IMG_CLS);
                            });
                            return _context3.abrupt("return", getKidmImgclsCollectFlag({
                              B_SNO: that.busiData.B_SNO,
                              BUSI_CODE: that.busiData.BUSI_CODE,
                              BUSI_DETAIL: that.busiData.BUSI_CODE,
                              SYS_CODE: "99",
                              CHANNEL: "13",
                              ACCEPT_PARAM: _JSON$stringify(that.busiData),
                              USER_TYPE: that.busiData.USER_TYPE
                            }).then(function () {
                              var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(resData) {
                                var res1;
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        consoleLog("调用表单是否需要重采接口成功", resData);

                                        if (!needOldImg) {
                                          _context2.next = 5;
                                          break;
                                        }

                                        _context2.next = 4;
                                        return that.getAllHistoryImg(imgAllArr, ignoreImgCls);

                                      case 4:
                                        res1 = _context2.sent;

                                      case 5:
                                        return _context2.abrupt("return", that.disPlayImgView(that.imgClsArr));

                                      case 6:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, _this2);
                              }));

                              return function (_x4) {
                                return _ref3.apply(this, arguments);
                              };
                            }()).catch(function (err) {
                              consoleLog("获取影像系统重新采集标志失败", err);
                            }));

                          case 19:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  consoleLog("需采集影像列表获取失败", err.toString());
                  that.confirm({
                    messageText: "获取影像列表失败:" + err,
                    confirmButtonText: "重试",
                    cancelButtonText: "上一步",
                    confirmedAction: function confirmedAction() {
                      return that.getBusiCollectInfo(needOldImg, ignoreImgCls);
                    },
                    canceledAction: function canceledAction() {
                      that.prevStep();
                    }
                  });
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }))();
    },
    getAllHistoryImg: function getAllHistoryImg(imgClsList, ignoreImgCls) {
      var _this3 = this;

      var that = this;

      consoleLog("查询当前流水号历史影像", this.busiData.B_SNO);
      return this.$syscfg.K_Request("F0000039", {
        B_SNO: this.busiData.B_SNO,
        filterImgSrc: "1",
        ID_CODE: this.busiData.ID_CODE
      }).then(function () {
        var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(data) {
          var formPrintCollectFlagArr, needDelList, delImgClsList;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return getPrintImgClsCollectFlag(that);

                case 2:
                  formPrintCollectFlagArr = _context5.sent;

                  consoleLog("表单打印的节点的影像类别的标志,", formPrintCollectFlagArr);
                  consoleLog("根据业务流水号，获取回来的的历史影像的数据:", data);

                  if (!(data.Code == "0")) {
                    _context5.next = 18;
                    break;
                  }

                  needDelList = [];
                  delImgClsList = new _Set();

                  (data.Data || []).forEach(function (val) {
                    if (imgClsList.indexOf(val.IMG_CLS) == -1 && ignoreImgCls.indexOf(val.IMG_CLS) === -1) {
                      needDelList.push(val.IMG_SN);
                      delImgClsList.add(val.IMG_CLS);
                    }
                    var item = _.find(that.imgClsArr, function (obj) {
                      return obj.IMG_CLS == val.IMG_CLS;
                    });
                    if (item) {
                      that.$set(item, "REVIEW_REMARK", val.REVIEW_REMARK);
                      that.$set(item, "REVIEW_STATUS", val.REVIEW_STATUS);
                      that.$set(item, "IMG_DATA", val.IMG_DATA);
                      that.$set(item, "SHOW_COLLECT_TIP", val.REVIEW_STATUS == "5" ? "重新采集" : ["0", "1", "4"].includes(val.REVIEW_STATUS) ? "已上传" : "未上传");
                      item.IMG_SN = val.IMG_SN;
                    }
                  });

                  _.each(formPrintCollectFlagArr, function (obj) {
                    var item = _.find(that.imgClsArr, function (temp) {
                      return temp.IMG_CLS == obj.IMG_CLS;
                    });
                    if (item) {
                      if (obj.RESET_FLAG == "1") {
                        that.$set(item, "RESET_FLAG", "1");
                        that.$set(item, "PRINT_STATUS", "0");
                      } else {
                        that.$set(item, "RESET_FLAG", "0");
                        that.$set(item, "PRINT_STATUS", "1");
                      }
                    }
                  });

                  if (!(needDelList.length > 0)) {
                    _context5.next = 15;
                    break;
                  }

                  consoleLog("删除已采集且本次不再需要的影像列表：", delImgClsList.toJSON());
                  return _context5.abrupt("return", _this3.deleteExcessImg(needDelList).then(function (res) {
                    return { Code: "0" };
                  }));

                case 15:
                  return _context5.abrupt("return", { Code: "0" });

                case 16:
                  _context5.next = 19;
                  break;

                case 18:
                  return _context5.abrupt("return", { Code: "-1" });

                case 19:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, _this3);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (err) {
        consoleLog("获取该客户该业务采集的所有历史影像", err);
      });
    },
    getHistoryImgByImgCls: function getHistoryImgByImgCls(IMG_CLS) {
      var filterImgSrc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0";

      var that = this;

      consoleLog("查询当前流水号历史影像", this.busiData.B_SNO);
      return this.$syscfg.K_Request("F0000039", {
        B_SNO: that.busiData.B_SNO,
        IMG_CLS: IMG_CLS,
        filterImgSrc: filterImgSrc,
        ID_CODE: that.busiData.ID_CODE
      }).then(function (data) {
        consoleLog("\u83B7\u53D6" + IMG_CLS + "\u5386\u53F2\u5F71\u50CF\u6570\u91CF:" + _.get(data, "Data[0].IMG_DATA.length"));
        if (data.Code == "0") {
          return data.Data[0];
        } else {
          throw data.Msg;
        }
      }).catch(function (err) {
        consoleLog("\u83B7\u53D6" + IMG_CLS + "\u5386\u53F2\u5F71\u50CF\u5931\u8D25" + _JSON$stringify(err));
        alert("\u83B7\u53D6" + IMG_CLS + "\u5386\u53F2\u5F71\u50CF\u5931\u8D25" + _JSON$stringify(err) + "!");
        throw false;
      });
    },
    deleteExcessImg: function deleteExcessImg(excessImg) {
      return this.$syscfg.K_Request("F0000045", {
        B_SNO: this.busiData.B_SNO,
        IMG_SNS: excessImg.join(",")
      });
    },
    disPlayImgView: function disPlayImgView(imgClsArr) {
      var _this4 = this;

      return _asyncToGenerator(_regeneratorRuntime.mark(function _callee6() {
        var mustCollectImg, i, v, flag;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this4.collectImgItems = [];
                _this4.reCollectImgItems = [];
                _this4.eSignSealItems = [];
                _this4.formItemItems = [];
                _this4.faceImgItems = [];
                _this4.ocrIImgtems = [];
                _this4.videoItems = [];
                _context6.next = 9;
                return oppService.getBusiCommonParams(_this4.busiCode, _this4.busiData.USER_TYPE == "2" ? "PRE_REVIEW_PRO_IMG_LIST" : "PRE_REVIEW_ORG_IMG_LIST");

              case 9:
                _context6.t0 = _context6.sent;

                if (_context6.t0) {
                  _context6.next = 12;
                  break;
                }

                _context6.t0 = [];

              case 12:
                mustCollectImg = _context6.t0;

                for (i = 0; i < imgClsArr.length; i++) {
                  v = imgClsArr[i];
                  flag = false;

                  if (["050", "071"].includes(v.IMG_CLS)) {
                    _this4.ocrIImgtems.push(v);
                    flag = true;
                  }
                  if (mustCollectImg.includes(v.IMG_CLS)) {
                    _this4.collectImgItems.push(v);

                    if (v.IMG_CLS !== "Xb6") {
                      _this4.reCollectImgItems.push(v);
                      flag = true;
                    }
                  } else if (["119", "070", "X13"].includes(v.IMG_CLS)) {
                    _this4.faceImgItems.push(v);
                    flag = true;
                  } else if (["X33", "X35"].includes(v.IMG_CLS)) {
                    _this4.videoItems.push(v);
                    flag = true;
                  }
                  if (!flag) {
                    _this4.eSignSealItems.push(v);
                  }
                  if (["0", "1", "8"].includes(v.IMG_GET_MODE) && !!v.E_SIGN_ADDR) {
                    _this4.formItemItems.push(v);
                  }
                }
                _this4.imgClsArr = [];

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    photoUse: function photoUse(imageMessage) {
      var _this5 = this;

      return _asyncToGenerator(_regeneratorRuntime.mark(function _callee7() {
        var that, mediaData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this5;
                mediaData = {
                  B_SNO: that.bSno,
                  BUSI_CODE: that.busiData.BUSI_CODE,
                  CUST_CODE: that.busiData.CUST_CODE,
                  SYS_CUST_NO: that.busiData.CUST_CODE,
                  CUST_NAME: that.busiData.CUST_NAME,
                  ID_TYPE: that.busiData.ID_TYPE,
                  ID_CODE: that.busiData.ID_CODE,
                  IMG_CLS: imageMessage.IMG_CLS,
                  IMG_CLS_NAME: imageMessage.IMG_CLS_NAME,
                  IMG_FMT: imageMessage.IMG_FMT,
                  REVIEW_STATUS: "1",
                  IMG_REMARK: "",
                  REVIEW_REMARK: " ",
                  PAGE_NUM: imageMessage.PAGE_NUM || "",
                  ORG_CODE: that.busiData.CUST_ORG_CODE,
                  ID_CARD: that.busiData.ID_CODE,
                  SYS_CODE: that.busiData.SYS_CODE,
                  CHANNEL: "13",
                  BUSI_DETAIL: "000",
                  IMG_DATA: imageMessage.imgSrc,
                  SHARE_FROM: imageMessage.SHARE_FROM || "0",
                  IS_OPEN_BIZ_CUST_CODE: that.busiData.IS_OPEN_BIZ_CUST_CODE || "",
                  WHETHER_COMMON_CLS: "1"
                };

                consoleLog("正在上传影像类别", mediaData.IMG_CLS);
                consoleLog("正在上传影像入参", mediaData);
                _this5.$store.commit(_this5.$types.UPDATE_LOADING, "\u6B63\u5728\u4E0A\u4F20\u5F71\u50CF" + imageMessage.IMG_CLS_NAME + "\uFF0C\u8BF7\u7A0D\u5019...");

                if (imageMessage.IMG_CLS) {
                  _context7.next = 9;
                  break;
                }

                that.alert("影像上传失败：无法获取到影像类别, 请返回首页后重试!");
                throw "影像上传失败：无法获取到影像类别";

              case 9:
                if (mediaData.B_SNO) {
                  _context7.next = 13;
                  break;
                }

                that.alert("影像上传失败 业务流水号不能为空, 请返回首页后重试!");
                throw "影像上传失败：无法获取到影像类别";

              case 13:
                if (imageMessage.imgSrc) {
                  _context7.next = 17;
                  break;
                }

                that.alert("影像上传失败：影像数据不能为空, 请返回首页后重试!");
                throw "影像上传失败：影像数据不能为空";

              case 17:
                return _context7.abrupt("return", upCollectedImgData(mediaData));

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    batchPhotoUse: function batchPhotoUse(imageMessage) {
      var _this6 = this;

      return _asyncToGenerator(_regeneratorRuntime.mark(function _callee8() {
        var that, mediaData, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this6;
                mediaData = {
                  B_SNO: _this6.busiData.KIDM_SNO,
                  USER_TYPE: that.busiData.USER_TYPE,
                  BUSI_CODE: that.busiData.BUSI_CODE,
                  CUST_NAME: that.busiData.CUST_NAME,
                  ID_TYPE: that.busiData.ID_TYPE,
                  ID_CARD: that.busiData.ID_CODE,
                  REVIEW_STATUS: "1",
                  IMG_REMARK: "",
                  REVIEW_REMARK: " ",
                  ORG_CODE: that.busiData.CUST_ORG_CODE,
                  SYS_CODE: that.busiData.SYS_CODE,
                  CHANNEL: "13",
                  BUSI_DETAIL: "000",
                  IMG_DATA_LIST: imageMessage.IMG_DATA_LIST || [],
                  impPageConfig: imageMessage.impPageConfig,
                  needCollectClsArr: imageMessage.needCollectClsArr };

                consoleLog("正在批量上传影像入参", mediaData);
                _this6.$store.commit(_this6.$types.UPDATE_LOADING, "\u6B63\u5728\u4E0A\u4F20\u5F71\u50CF" + imageMessage.IMG_CLS_NAME + "\uFF0C\u8BF7\u7A0D\u5019...");

                if (mediaData.B_SNO) {
                  _context8.next = 8;
                  break;
                }

                that.alert("影像上传失败：影像流水号不能为空, 请返回首页后重试!");
                throw "影像上传失败：无法获取到影像流水号";

              case 8:
                if (mediaData.IMG_DATA_LIST.length) {
                  _context8.next = 12;
                  break;
                }

                that.alert("影像上传失败：影像数据不能为空, 请返回首页后重试!");
                throw "影像上传失败：影像数据不能为空";

              case 12:
                _context8.next = 14;
                return batchUpCollectedImgData(mediaData);

              case 14:
                res = _context8.sent;
                return _context8.abrupt("return", res);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },
    deleteSysImg: function deleteSysImg(index, imgSn, deleteImgList) {
      var _this7 = this;

      var that = this;
      var param = {
        IMG_SN: imgSn,
        PAGE_NUMS: deleteImgList[index],
        B_SNO: that.busiData.KIDM_SNO };
      that.$store.commit(that.$types.UPDATE_LOADING, "正在删除影像...");
      return deleteCollectedImgData(param).then(function (res) {
        if (res.Code == "0") {
          if (index < deleteImgList.length - 1) {
            index++;
            return _this7.deleteSysImg(index, imgSn, deleteImgList);
          } else {
            return true;
          }
        } else {
          throw "删除失败" + res.Msg;
        }
      }).catch(function (err) {
        consoleLog("影像删除失败", err);
        _this7.alert("影像删除失败！");
        return false;
      }).finally(function () {
        that.$store.commit(that.$types.UPDATE_LOADING, false);
      });
    },
    finishScan: function finishScan() {
      this.initPage();
    },
    validateImg: function validateImg(checkNoStamp) {
      var _this8 = this;

      return _asyncToGenerator(_regeneratorRuntime.mark(function _callee9() {
        var allImgArr, isAllCollect;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                allImgArr = [];

                if (_this8.imgType == "uploadImg") {
                  allImgArr = _this8.collectImgItems;
                } else if (_this8.imgType == "uploadForm") {
                  allImgArr = _.uniq(_this8.reCollectImgItems.concat(_this8.eSignSealItems).concat(_this8.collectImgItems).concat(_this8.ocrIImgtems).concat(_this8.faceImgItems).concat(_this8.formItemItems));
                } else {}
                _context9.next = 4;
                return _this8.checkAllImage(allImgArr, checkNoStamp);

              case 4:
                isAllCollect = _context9.sent;
                return _context9.abrupt("return", isAllCollect);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8);
      }))();
    },
    checkAllImage: function checkAllImage(imgClsArr, checkNoStamp) {
      var _this9 = this;

      var noCollectImg = [];
      for (var i = 0; i < imgClsArr.length; i++) {
        var initObj = imgClsArr[i];
        var cls = initObj.IMG_CLS;

        if ((["0", "1", "4"].indexOf(initObj.REVIEW_STATUS) === -1 || checkNoStamp && initObj.REVIEW_REMARK == "缺章") && initObj.COLLECT_MUST == "1") {
          noCollectImg.push({ imgCls: initObj.IMG_CLS, imgClsName: initObj.IMG_CLS_NAME });
        }
      }
      if (noCollectImg.length) {
        var noCollectImgStr = noCollectImg.map(function (v) {
          return v.imgCls + v.imgClsName;
        }).join(",");
        return new _Promise(function (resolve) {
          _this9.alert({
            messageText: "请采集以下影像后再提交：" + noCollectImgStr,

            confirmButtonText: "返回采集"
          });
          if (_this9.isTest == "1") {
            resolve(true);
            return;
          }
          resolve(false);
        });
      } else {
        consoleLog("影像已采集，校验通过，可以下一步");
        return true;
      }
    },
    prevStep: function prevStep() {
      var idx = this.getPrevShowPageIndex();
      if (idx !== -1) {
        this.$router.goRoute(idx);
      } else {
        consoleLog("已到头部");
        return -1;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/imageNode/child/imgCommonMixins.js
// module id = 286
// module chunks = 2